import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend, CartesianGrid } from "recharts";

const GOLD = "#E9A400";
const NAVY = "#0A1C30";

const Progress = ({ c }) => {
  const pct = Math.min(100, Math.round((c.value / (c.max || 1)) * 100));
  return (
    <div>
      <div className="flex justify-between text-xs font-bold text-[#4A5568] mb-1.5"><span>{c.value} / {c.max}</span><span>{pct}%</span></div>
      <div className="h-3 rounded-full bg-[#EEF1F5] overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct}%`, background: pct >= 70 ? "#1E9E5A" : pct >= 40 ? GOLD : "#D64545" }} />
      </div>
      {c.extra ? <div className="text-[11px] text-[#6B7688] mt-1">Excelencia: {c.extra}</div> : null}
    </div>
  );
};

const Donut = ({ c }) => {
  const data = c.data.filter((d) => d.value > 0);
  if (!data.length) return <div className="text-xs text-[#6B7688]">Sin datos aún.</div>;
  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie data={data} dataKey="value" nameKey="name" innerRadius={45} outerRadius={75} paddingAngle={2}>
          {data.map((d, i) => <Cell key={i} fill={d.color} />)}
        </Pie>
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 11 }} />
      </PieChart>
    </ResponsiveContainer>
  );
};

const Bars = ({ c, horizontal }) => (
  <ResponsiveContainer width="100%" height={horizontal ? Math.max(160, c.data.length * 38) : 220}>
    <BarChart data={c.data} layout={horizontal ? "vertical" : "horizontal"} margin={{ left: horizontal ? 10 : -10, right: 10 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#EEF1F5" />
      {horizontal ? <><XAxis type="number" domain={[0, 100]} tick={{ fontSize: 10 }} /><YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 10 }} /></>
        : <><XAxis dataKey="name" tick={{ fontSize: 9 }} interval={0} angle={-20} textAnchor="end" height={50} /><YAxis tick={{ fontSize: 10 }} /></>}
      <Tooltip />
      {c.keys.map((k, i) => (
        <Bar key={k} dataKey={k} fill={i === 0 ? GOLD : NAVY} radius={4}>
          {horizontal && c.data.map((d, j) => <Cell key={j} fill={d[k] >= 70 ? "#1E9E5A" : d[k] >= 40 ? GOLD : "#D64545"} />)}
        </Bar>
      ))}
      {c.keys.length > 1 && <Legend wrapperStyle={{ fontSize: 11 }} />}
    </BarChart>
  </ResponsiveContainer>
);

export const AnaChart = ({ c, i }) => (
  <div className="rounded-2xl bg-white ring-1 ring-black/5 p-4" data-testid={`ana-chart-${i}`}>
    <div className="text-xs font-extrabold text-[#0A1C30] mb-3">{c.title}</div>
    {c.type === "progress" ? <Progress c={c} /> : c.type === "donut" ? <Donut c={c} /> : <Bars c={c} horizontal={c.type === "bar_h"} />}
  </div>
);
